type BrowserNavigator = Pick<Navigator, 'userAgent' | 'platform' | 'maxTouchPoints'>;

const getNavigator = (nav?: BrowserNavigator): BrowserNavigator | null => {
  if (nav) return nav;

  if (typeof navigator === 'undefined') return null;

  return navigator;
};

export const isIpadDevice = (nav?: BrowserNavigator): boolean => {
  const browserNavigator = getNavigator(nav);
  if (!browserNavigator) return false;

  const ua = browserNavigator.userAgent;

  // iPadOS 12 and lower identify directly as `iPad`.
  if (/iPad/i.test(ua)) return true;

  // iPadOS 13+ may report as Mac; detect by touch capability.
  return browserNavigator.platform === 'MacIntel' && browserNavigator.maxTouchPoints > 1;
};

export const isSafariBrowser = (nav?: BrowserNavigator): boolean => {
  const browserNavigator = getNavigator(nav);
  if (!browserNavigator) return false;

  const ua = browserNavigator.userAgent;

  return /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS/i.test(ua);
};
